module.exports = __webpack_public_path__ + "img/20250821_2.2c122ad2.png";